export default __webpack_public_path__ + "static/media/graphInter.71652d8d.png";